import { useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';

/** Kopieerknop per veld, voor plakken in het HIS (Sara-SOEP en verwijsbrief). */
export function CopyFieldButton({
  text,
  title = 'Kopieer dit veld naar het HIS',
  label = 'Kopieer',
  onCopy,
  disabled = false,
}: {
  text: string;
  title?: string;
  label?: string;
  onCopy?: () => void;
  disabled?: boolean;
}): JSX.Element {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      onClick={() => {
        void navigator.clipboard.writeText(text);
        onCopy?.();
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }}
      disabled={disabled || !text}
      title={title}
      className="inline-flex items-center gap-1 rounded-md border border-brand-100 bg-white px-2 py-1 text-[11px] font-medium text-ink-900/70 transition-colors hover:border-brand-300 hover:text-ink-900 disabled:opacity-40"
    >
      {copied ? (
        <CheckIcon size={12} strokeWidth={2.5} className="text-brand-500" />
      ) : (
        <CopyIcon size={12} strokeWidth={2} />
      )}
      {copied ? 'Gekopieerd' : label}
    </button>
  );
}
